<template>
  <div class="hwh-calculator__block">
    <div class="hwh-calculator__sub">
      Select Possible Local Rebates & Incentives
    </div>
    <swiper class="swiper hwh-calculator__slider" :options="swiperOption" v-if="rebatePrograms.length > 0">
      <swiper-slide class="hwh-calculator__slide" v-for="(item, key) in rebatePrograms" :key="key">
        <label class="hwh-calculator__slide-inner">
          <input type="checkbox" class="hwh-calculator__slide-checkbox" v-model="item.checked" :disabled="!item.enabled"/>
          <div class="hwh-calculator__slide-title">{{ item.name }}</div>
          <div class="hwh-calculator__slide-disabled" v-if="!item.enabled">* calculated savings for this rebate is currently not available</div>
          <div class="hwh-calculator__row">
            <div class="hwh-calculator__col">
              <div class="hwh-calculator__slide-price">{{ item.amountLabel }}</div>
            </div>
            <div class="hwh-calculator__col-auto">
              <a :href="item.claimFormURL" class="hwh-calculator__slide-link" target="_blank">Claim Form</a>
            </div>
          </div>
          <div class="hwh-calculator__slide-text">
            <ul>
              <li v-for="(importantDetail, index) in item.importantDetails" :key="'important-detail-' + index">{{ importantDetail }}</li>
              <li v-for="(validDate, index) in item.validDates" :key="'valid-date-' + index">{{ validDate }}</li>
            </ul>
          </div>
        </label>
      </swiper-slide>
    </swiper>
    <div class="hwh-calculator__total-block hwh-calculator__input-block">
      <span v-if="totalRebateValue">Total ${{ totalRebateValue }}</span>
      <span v-else>&nbsp;</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// eslint-disable-next-line import/extensions
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

import 'swiper/swiper.scss';

export default {
  name: 'Step2',
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapState(['rebatePrograms']),
    ...mapGetters(['totalRebateValue']),
  },
  data() {
    return {
      swiperOption: {
        loop: false,
        freeMode: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 16,
            autoHeight: false,
          },
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.productSliderWidget__next',
          prevEl: '.productSliderWidget__prev',
        },
      },
    };
  },
  methods: {},
};
</script>
